// Library Imports
import { lazy } from 'react';

// Local Imports
import { ROUTE_PATHS } from '@/router/constants';

// Lazy load components for code splitting
const Login = lazy(() => import('@/panels/Auth/Login'));
const CreateSampleKit = lazy(() => import('@/panels/Auth/CreateSampleKit'));
const ForgotPassword = lazy(() => import('@/panels/Auth/ForgotPassword'));

// Public Routes
export const publicRoutes = [
  {
    path: ROUTE_PATHS.LOGIN,
    moduleName: 'Authentication',
    element: <Login />
  },
  {
    path: ROUTE_PATHS.REGISTRATION,
    moduleName: 'Authentication',
    element: <CreateSampleKit />
  },
  {
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    moduleName: 'Authentication',
    element: <ForgotPassword />
  }
];

